import { AnomalyHistoryProperty } from '@api/twin/AnomalyApi';
import { ArrowLongRightIcon } from '@heroicons/react/24/solid';
import { Icon } from '@stereograph/teia-system-design/components/Icon';
import { Text } from '@stereograph/teia-system-design/components/Typography';
import { usePluginTranslation } from '@translation';
import { AnomalyHistoryItemBase } from './AnomalyHistoryItemBase';

interface AnomalyHistoryItemDeletedProps {
  property: AnomalyHistoryProperty;
}

export const AnomalyHistoryItemDeleted = (props: AnomalyHistoryItemDeletedProps) => {
  const { property } = props;
  const { t } = usePluginTranslation();

  return (
    <AnomalyHistoryItemBase
      chipColor="error"
      chipLabel={t('anomaly_plugin.widget.history.deleted.label')}
    >
      <Text bold>{property.propertyName}</Text>
      <Icon
        component={ArrowLongRightIcon}
        sx={{
          width: 15,
        }}
      />
      <Text>{property.oldValue}</Text>
    </AnomalyHistoryItemBase>
  );
};
